import { createAsyncThunk } from "@reduxjs/toolkit";

import { dataServer } from "~/constants";
import type { DbDataType } from "~/types/general";

export interface UpdateOperation {

  where: Record<string, any>;
  data: Record<string, any>;
}
export const updatePromise = async (url: string, object: Record<string, any> | Record<string, any>[]) => {
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(object),
      });
      const data = await response.json();
      console.log("updateDocument response", data);
      if (!response.ok) {
        throw new Error(data);
      }
      return data;
    } catch (error) {
      throw error;
    }
  }

export const updateSingleThunk = createAsyncThunk(
  "organization/updateSingleThunk",
  async ({ dataType, data }: { dataType: DbDataType; data: Record<string, any> }, { rejectWithValue, dispatch }) => {

    const url = `${dataServer}single/${dataType}/${data.id}`;
    try {
      const result = await updatePromise(
        url,
        data
      )

      // dispatch(setOrgani)
      if (result.success) {
        return {
          dataType, 
          data: result.data
        };
      } else {
        return rejectWithValue("Update failed");
      }

    } catch (error: any) {
      return rejectWithValue(error.message);
    }

  }
);
export const updateBulkThunk = createAsyncThunk(
  "organization/updateBulkThunk",
  async ({ dataType, data }: { dataType: DbDataType; data: Record<string, any>[] }, { rejectWithValue, dispatch }) => {
    console.log("updateBulkThunk params", { dataType, data });
    const url = `${dataServer}bulk/${dataType}`;
    try {
      const result = await updatePromise(
        url,
        data
      )
      console.log("updateBulkThunk result", result);
      // dispatch(setOrgani)
      if (result.success) {
        return {
          dataType, 
          data
        };
      } else {
        return rejectWithValue("Update failed");
      }

    } catch (error: any) {
      return rejectWithValue(error.message);
    }

  }
);


